(function () {
	'use strict';

	angular.module('qbePortal').controller('FieldWrapper', FieldWrapper);

	FieldWrapper.$inject = ['$scope', 'labelService', '$sce', '$filter', 'gtmService'];

	function FieldWrapper($scope, labelService, $sce, $filter, gtmService) {
		var vm = this,
			fieldKey = $scope.fieldKey,
			qbTrack = $scope.qbTrack;

		vm.fieldName = $scope.name;
		vm.showErrorBottom = $scope.showErrorBottom;
		vm.isError = false;
		vm.hintCatcher = null;
		vm.expandHintText = $scope.expandHintText == undefined ? false : $scope.expandHintText;

		vm.getGlobalOptionLabel = function (optionType, optionValue) {
			return labelService.getGlobalOptionLabel(optionType, optionValue);
		}

		$scope.$on('enable-field-error-class', function (event) {			
			vm.isError = true;
		});

		$scope.$on('element-id-set', function (event, labelKey, id) {
			if (fieldKey !== labelKey) return;
			vm.labelFor = id;
		});

		$scope.$on('hide-hint', function(event){
			vm.showHint = false;
		});

		$scope.$on('show-hint', function(event){
			setTimeout(function () {
				QBE.expandCollapse.init();
			}, 1000)			
			vm.showHint = true;
		});		


		// If there's a fieldKey, look up all the labels/helptext
		if (fieldKey) {
			//Additional hint param
			vm.showHint = true;
			
			// Wildcard
			vm.labelWildcard = $scope.labelWildcard;

			// Label
			vm.label = labelService.getLabelFor(fieldKey);

			// Hide labels which are used for accessibility
			vm.hideLabel = $scope.hasOwnProperty('hideLabel');

			// Tooltip
			vm.tooltip = labelService.getTooltipFor(fieldKey);

			// HTML Label
			// vm.labelMarkup = $sce.trustAsHtml(labelService.getLabelFor(fieldKey));

			// Help Text
			if(typeof vm.labelWildcard == 'string' || typeof vm.labelWildcard == 'undefined'){
				vm.hintText = $sce.trustAsHtml($filter('wildcardReplace')(labelService.getHintTextFor(fieldKey), vm.labelWildcard));			
			}else{
				// Handle multiple wildcard
				var argArr = [];
				argArr.push(labelService.getHintTextFor(fieldKey));
				argArr = argArr.concat(vm.labelWildcard);
				vm.hintText = $sce.trustAsHtml($filter('wildcardReplace').apply(null, argArr));			
			}
			
			// Extended Help Text
			// TODO: fix this to not use timeout
			setTimeout(function () {
				QBE.expandCollapse.init();
			}, 1000)
			vm.helpText = $sce.trustAsHtml(labelService.getHelpTextFor(fieldKey));

			// Secondary info Text
			vm.secondaryInfoText = $sce.trustAsHtml(labelService.getSecondaryInfoTextFor(fieldKey));
		}

		vm.getLabel = function () {
			var label = vm.label;

			vm.labelWildcard = $scope.labelWildcard;

			if (vm.labelWildcard) {
				label = $filter('wildcardReplace')($sce.trustAsHtml(vm.label), vm.labelWildcard);
			}

			return label;
		}

		vm.showImageRefForPayment = function(data) {
			console.log(data);
			if(data == 'enterPaymentRef') {
				angular.element('#pay-img-ref').toggleClass('ng-hide');
			}
		}

		/*
			When select a product from drop down
			validate product and do Gtm tracking
		*/
		vm.tooltipMouseOver = function(tooltipMessage) {
			if (qbTrack === 'true') {
				gtmService.trackTooltipMouseOver(tooltipMessage);
			}
		}
	}

	angular.module('qbePortal').directive('qbFieldWrapper', function () {
		return {
			templateUrl: '/ngviews/directives/qbFieldWrapper.html',
			restrict: 'A',
			controller: FieldWrapper,
			controllerAs: 'vm',
			transclude: true,
			scope: {
				fieldKey: '@',
				hideLabel: '@?',
				labelWildcard: '<',
				secondaryInfoTextDisplayOn: '=?',
				validationSelector: '@',
				showErrorBottom: '@',
				expandHintText: '=',
				qbTrack:'@?',
			}
		}
	});
})();
